import * as d3Color from 'd3-color';
import * as jQuery from 'jquery';

import { Injectable } from '@angular/core';

import { COLORS } from '../../analytics/constants/analytics.constants';
import { ColorPalette } from '../interfaces/partner.interface';

/**
 *
 */
@Injectable()
export class ColorUtilityService {
	/**
	 *
	 */
	constructor() {}

	loadStyleSheets(styleUrls: string[]): void {
		// tslint:disable-next-line:no-parameter-reassignment
		styleUrls = styleUrls ? styleUrls : [];
		for (let i = 0; i < styleUrls.length; i++) {
			if (document.getElementById('custom-style' + i)) {
				// remove element
				// tslint:disable-next-line: prefer-template
				jQuery('link[title="custom-style' + i + '"]').remove();
			}
			const link = document.createElement('link');
			link.title = 'custom-style' + i;
			link.id = 'custom-style' + i;
			link.rel = 'stylesheet';
			link.href = styleUrls[i];
			document.head.appendChild(link);
		}
	}

	public getRGBByOpacity(hex: string, opacity: number): string {
		return this.generateRGBCssProperty(this.getRGBFromHex(hex), opacity);
	}

	getRGBByColorType(colorPalette: ColorPalette, colorType: string, opacity: number): any {
		const hex = this.getHEXByColorType(colorPalette, colorType, opacity);
		return this.getRGBByOpacity(hex, opacity);
	}

	getHEXByColorType(colorPalette: ColorPalette, colorType: string, opacity: number): any {
		let hex = '';
		// tslint:disable-next-line: no-parameter-reassignment
		colorType = colorType ? colorType.trim() : colorType;
		switch (colorType) {
			case COLORS.PRIMARY: {
				hex = colorPalette.primaryColor;
				break;
			}

			case COLORS.SECONDARY: {
				hex = colorPalette.secondaryColor;
				break;
			}

			case COLORS.TERTIARY: {
				hex = colorPalette.tertiaryColor;
				break;
			}

			case COLORS.QUATERNARY: {
				hex = colorPalette.quaternaryColor;
				break;
			}

			case COLORS.QUINARY: {
				hex = colorPalette.quinaryColor;
				break;
			}
		}
		return hex;
	}

	public removeStyleSheets(styleUrls: string[]): void {
		for (let i = 0; i < styleUrls.length; i++) {
			if (document.getElementById('custom-style' + i)) {
				// remove element
				// tslint:disable-next-line: prefer-template
				jQuery('link[title="custom-style' + i + '"]').remove();
			}
		}
	}

	public buildStylesFromColorPalette(colorPalette: ColorPalette): void {
		let colorPaletteCSS = "<style id='customCSS' type='text/css'>";
		colorPaletteCSS +=
			this.buildColors(colorPalette) +
			this.buildBackgroundColors(colorPalette) +
			this.buildBorderColors(colorPalette) +
			this.miscellaneousStyles(colorPalette);
		colorPaletteCSS += '</style>';
		jQuery(colorPaletteCSS).appendTo('head');
	}

	public buildStylesFromColorPaletteTwo(colorPalette: ColorPalette): void {
		let colorPaletteCSS = "<style id='customCSSTwo' type='text/css'>";
		colorPaletteCSS += this.mapStyles(colorPalette) + this.creativePerformanceCarouselStyles(colorPalette);
		colorPaletteCSS += '</style>';
		jQuery(colorPaletteCSS).appendTo('head');
	}

	public clearStylesFromHead(): void {
		jQuery('#customCSS').remove();
		jQuery('#customCSSTwo').remove();
	}
	public getBrightColor(color: any, brightNumber: number, fillOpacity: number): string {
		// tslint:disable-next-line: no-parameter-reassignment
		color = d3Color.color(color);
		color.opacity = 1 - fillOpacity;
		color.brighter([brightNumber + 30]);
		return color.toString();
	}

	public getDarkColor(color: any, darkNumber: number, fillOpacity: number): string {
		// tslint:disable-next-line: no-parameter-reassignment
		color = d3Color.color(color);
		color.opacity = 1 - fillOpacity;
		color.darker([darkNumber + 30]);
		return color.toString();
	}

	private getBackGroundGraidentColor(color: any, opacity: number): string {
		// tslint:disable-next-line: no-parameter-reassignment
		color = d3Color.color(color);
		color.opacity = opacity;
		return color.toString();
	}

	private buildBackgroundColors(colorPalette: ColorPalette): string {
		const backgroundStyles = `
		:root {
			--primary-color : ${colorPalette.primaryColor};
			--secondary-color : ${colorPalette.secondaryColor};
			--tertiary-color : ${colorPalette.tertiaryColor};
			--quaternary-color : ${colorPalette.quaternaryColor};
			--quinary-color : ${colorPalette.quinaryColor};
			--secondary-color-15 : ${this.getRGBByOpacity(colorPalette.secondaryColor, 0.15)};
			--secondary-color-30 : ${this.getRGBByOpacity(colorPalette.secondaryColor, 0.3)};
			--secondary-color-50 : ${this.getRGBByOpacity(colorPalette.secondaryColor, 0.5)};
			--tertiary-color-30 : ${this.getRGBByOpacity(colorPalette.tertiaryColor, 0.3)};
			--tertiary-color-05 : ${this.getRGBByOpacity(colorPalette.tertiaryColor, 0.05)};
			--secondary-color-90 : ${this.getRGBByOpacity(colorPalette.secondaryColor, 0.9)};
			--primary-color-15 : ${this.getRGBByOpacity(colorPalette.primaryColor, 0.15)};
			--primary-color-50 : ${this.getRGBByOpacity(colorPalette.primaryColor, 0.5)};
			--primary-color-90 : ${this.getRGBByOpacity(colorPalette.primaryColor, 0.9)};
		}
		.primary-color-bg {
			background-color: ${colorPalette.primaryColor} !important;
		}
		.secondary-color-bg {
			background-color: ${colorPalette.secondaryColor} !important;
		}
		.tertiary-color-bg {
			background-color: ${colorPalette.tertiaryColor} !important;
		}
		.quaternary-color-bg {
			background-color: ${colorPalette.quaternaryColor} !important;
		}
		.quinary-color-bg {
			background-color: ${colorPalette.quinaryColor} !important;
		}
		.tertiary-color-bg-opacity {
			background-color: ${this.getRGBByOpacity(colorPalette.tertiaryColor, 0.5)} !important;
		}
		.primary-color-bg-on-hover:hover {
			background-color: ${this.getRGBByOpacity(colorPalette.primaryColor, 0.5)} !important;
		}
		.primary-color-bg-on-hover-0-15:hover {
			background-color: ${this.getRGBByOpacity(colorPalette.primaryColor, 0.15)} !important;
		}
		.primary-color-bg-on-hover100:hover {
			background-color: ${this.getRGBByOpacity(colorPalette.primaryColor, 1)} !important;
		}
		.primary-color-bg-gradient {
			background: linear-gradient(to bottom, ${this.getBackGroundGraidentColor(
				colorPalette.primaryColor,
				0.6
			)}, ${this.getBackGroundGraidentColor(colorPalette.primaryColor, 1)}, ${this.getBackGroundGraidentColor(
			colorPalette.primaryColor,
			1
		)}) !important;
		}
		.secondary-color-bg-gradient {
			background: linear-gradient(to bottom,
				${this.getBackGroundGraidentColor(colorPalette.secondaryColor, 0.6)},
				${this.getBackGroundGraidentColor(colorPalette.secondaryColor, 1)},
				${this.getBackGroundGraidentColor(colorPalette.secondaryColor, 1)}) !important;
		}
		.tertiary-color-bg-gradient {
			background: linear-gradient(to bottom,
				${this.getBackGroundGraidentColor(colorPalette.tertiaryColor, 0.6)},
				${this.getBackGroundGraidentColor(colorPalette.tertiaryColor, 1)},
				${this.getBackGroundGraidentColor(colorPalette.tertiaryColor, 1)}) !important;
		}
		.quaternary-color-bg-gradient {
			background: linear-gradient(to bottom,
				${this.getBackGroundGraidentColor(colorPalette.quaternaryColor, 0.6)},
				${this.getBackGroundGraidentColor(colorPalette.quaternaryColor, 1)},
				${this.getBackGroundGraidentColor(colorPalette.quaternaryColor, 1)}) !important;
		}
		.quinary-color-bg-gradient {
			background: linear-gradient(to bottom,
				${this.getBackGroundGraidentColor(colorPalette.quinaryColor, 0.6)},
				${this.getBackGroundGraidentColor(colorPalette.quinaryColor, 1)},
				${this.getBackGroundGraidentColor(colorPalette.quinaryColor, 1)}) !important;
		}
		.primary-color-bg-right-gradient {
			background: linear-gradient(to right,
				${this.getBackGroundGraidentColor(colorPalette.primaryColor, 0.6)},
				${this.getBackGroundGraidentColor(colorPalette.primaryColor, 1)},
				${this.getBackGroundGraidentColor(colorPalette.primaryColor, 1)}) !important;
		}
		.secondary-color-bg-right-gradient {
			background: linear-gradient(to right,
				${this.getBackGroundGraidentColor(colorPalette.secondaryColor, 0.6)},
				${this.getBackGroundGraidentColor(colorPalette.secondaryColor, 1)},
				${this.getBackGroundGraidentColor(colorPalette.secondaryColor, 1)}) !important;
		}
		.tertiary-color-bg-right-gradient {
			background: linear-gradient(to right,
				${this.getBackGroundGraidentColor(colorPalette.tertiaryColor, 0.6)},
				${this.getBackGroundGraidentColor(colorPalette.tertiaryColor, 1)},
				${this.getBackGroundGraidentColor(colorPalette.tertiaryColor, 1)}) !important;
		}
		.quaternary-color-bg-right-gradient {
			background: linear-gradient(to right,
				${this.getBackGroundGraidentColor(colorPalette.quaternaryColor, 0.6)},
				${this.getBackGroundGraidentColor(colorPalette.quaternaryColor, 1)},
				${this.getBackGroundGraidentColor(colorPalette.quaternaryColor, 1)}) !important;
		}
		.quinary-color-bg-right-gradient {
			background: linear-gradient(to right,
				${this.getBackGroundGraidentColor(colorPalette.quinaryColor, 0.6)},
				${this.getBackGroundGraidentColor(colorPalette.quinaryColor, 1)},
				${this.getBackGroundGraidentColor(colorPalette.quinaryColor, 1)}) !important;
		}
		`;
		return backgroundStyles;
	}

	private buildBorderColors(colorPalette: ColorPalette): string {
		const borderColorStyles = `
		.primary-color-border {
			border-color: ${colorPalette.primaryColor} !important;
		}
		.secondary-color-border {
			border-color: ${colorPalette.secondaryColor} !important
		}
		.tertiary-color-border {
			border-color: ${colorPalette.tertiaryColor} !important
		}
		.quaternary-color-border {
			border-color: ${colorPalette.quaternaryColor} !important
		}
		.quinary-color-border {
			border-color: ${colorPalette.quinaryColor} !important
		}
		.primary-color-border-left {
			border-left-color: ${colorPalette.primaryColor} !important
		}
		.secondary-color-border-left {
			border-left-color: ${colorPalette.secondaryColor} !important
		}
		.tertiary-color-border-left {
			border-left-color: ${colorPalette.tertiaryColor} !important
		}
		.quaternary-color-border-left {
			border-left-color: ${colorPalette.quaternaryColor} !important
		}
		.quinary-color-border-left {
			border-left-color: ${colorPalette.quinaryColor} !important
		}
		.primary-color-border-left-opacity {
			border-left-color: ${this.getRGBByOpacity(colorPalette.primaryColor, 0.5)} !important;
		}
		.secondary-color-border-left-opacity {
			border-left-color: ${this.getRGBByOpacity(colorPalette.secondaryColor, 0.5)} !important;
		}
		.tertiary-color-border-left-opacity {
			border-left-color: ${this.getRGBByOpacity(colorPalette.tertiaryColor, 0.5)} !important;
		}
		.quaternary-color-border-left-opacity {
			border-left-color: ${this.getRGBByOpacity(colorPalette.quaternaryColor, 0.5)} !important;
		}
		.quinary-color-border-left-opacity {
			border-left-color: ${this.getRGBByOpacity(colorPalette.quinaryColor, 0.5)} !important;
		}
		.primary-color-border-right {
			border-right-color: ${colorPalette.primaryColor} !important;
		}
		.secondary-color-border-right {
			border-right-color: ${colorPalette.secondaryColor} !important;
		}
		.tertiary-color-border-right {
			border-right-color: ${colorPalette.tertiaryColor} !important;
		}
		.quaternary-color-border-right {
			border-right-color: ${colorPalette.quaternaryColor} !important;
		}
		.quinary-color-border-right {
			border-right-color: ${colorPalette.quinaryColor} !important;
		}
		.primary-color-border-right-opacity {
			border-right-color: ${this.getRGBByOpacity(colorPalette.primaryColor, 0.5)} !important;
		}
		.secondary-color-border-right-opacity {
			border-right-color: ${this.getRGBByOpacity(colorPalette.secondaryColor, 0.5)} !important;
		}
		.tertiary-color-border-right-opacity {
			border-right-color: ${this.getRGBByOpacity(colorPalette.tertiaryColor, 0.5)} !important;
		}
		.quaternary-color-border-right-opacity {
			border-right-color: ${this.getRGBByOpacity(colorPalette.quaternaryColor, 0.5)} !important;
		}
		.quinary-color-border-right-opacity {
			border-right-color: ${this.getRGBByOpacity(colorPalette.quinaryColor, 0.5)} !important;
		}
		.primary-color-border-bottom {
			border-bottom-color: ${colorPalette.primaryColor} !important;
		}
		.secondary-color-border-bottom {
			border-bottom-color: ${colorPalette.secondaryColor} !important;
		}
		.tertiary-color-border-bottom {
			border-bottom-color: ${colorPalette.tertiaryColor} !important;
		}
		.quaternary-color-border-bottom {
			border-bottom-color: ${colorPalette.quaternaryColor} !important;
		}
		.quinary-color-border-bottom {
			border-bottom-color: ${colorPalette.quinaryColor} !important;
		}
		.primary-color-border-bottom-opacity {
			border-bottom-color: ${this.getRGBByOpacity(colorPalette.primaryColor, 0.5)} !important;
		}
		.secondary-color-border-bottom-opacity {
			border-bottom-color: ${this.getRGBByOpacity(colorPalette.secondaryColor, 0.5)} !important;
		}
		.tertiary-color-border-bottom-opacity {
			border-bottom-color: ${this.getRGBByOpacity(colorPalette.tertiaryColor, 0.5)} !important;
		}
		.quaternary-color-border-bottom-opacity {
			border-bottom-color: ${this.getRGBByOpacity(colorPalette.quaternaryColor, 0.5)} !important;
		}
		.quinary-color-border-bottom-opacity {
			border-bottom-color: ${this.getRGBByOpacity(colorPalette.quinaryColor, 0.5)} !important;
		}
		.primary-color-border-top {
			border-top-color: ${colorPalette.primaryColor} !important;
		}
		.secondary-color-border-top {
			border-top-color: ${colorPalette.secondaryColor} !important;
		}
		.tertiary-color-border-top {
			border-top-color: ${colorPalette.tertiaryColor} !important;
		}
		.quaternary-color-border-top {
			border-top-color: ${colorPalette.quaternaryColor} !important;
		}
		.quinary-color-border-top {
			border-top-color: ${colorPalette.quinaryColor} !important;
		}
		.primary-color-border-top-opacity {
			border-top-color: ${this.getRGBByOpacity(colorPalette.primaryColor, 0.5)} !important;
		}
		.secondary-color-border-top-opacity {
			border-top-color: ${this.getRGBByOpacity(colorPalette.secondaryColor, 0.5)} !important;
		}
		.tertiary-color-border-top-opacity {
			border-top-color: ${this.getRGBByOpacity(colorPalette.tertiaryColor, 0.5)} !important;
		}
		.quaternary-color-border-top-opacity {
			border-top-color: ${this.getRGBByOpacity(colorPalette.quaternaryColor, 0.5)} !important;
		}
		.quinary-color-border-top-opacity {
			border-top-color: ${this.getRGBByOpacity(colorPalette.quinaryColor, 0.5)} !important;
		}`;
		return borderColorStyles;
	}

	private buildColors(colorPalette: ColorPalette): string {
		const colorStyles = `
			.primary-color {
				color: ${colorPalette.primaryColor} !important;
			}
			.secondary-color {
				color: ${colorPalette.secondaryColor} !important;
			}
			.tertiary-color {
				color: ${colorPalette.tertiaryColor} !important;
			}
			.quaternary-color {
				color: ${colorPalette.quaternaryColor} !important;
			}
			.quinary-color {
				color: ${colorPalette.quinaryColor} !important;
			}
			.primary-color:hover {
				color: ${colorPalette.primaryColor} !important;
			}
			.second-level-nav ul li.nav-active, .second-level-nav ul li.nav-active:after {
				color: ${colorPalette.primaryColor} !important;
			}`;
		return colorStyles;
	}

	private miscellaneousStyles(colorPalette: ColorPalette): string {
		const miscStyles = `
			.c-offcanvas__categories .c-menu .c-menu__item:hover .c-menu__link,
			.c-offcanvas__categories .c-menu .c-menu__item:hover .c-menu__icon {
				color: ${colorPalette.primaryColor}  !important;
			}
			.c-topbar__mainLink:hover {
				color: ${colorPalette.primaryColor}  !important;
			}
			.ngx-datatable.datatable .datatable-footer .datatable-pager li.active, .ngx-datatable.datatable .datatable-footer .datatable-pager li.active:hover {
				background: ${colorPalette.primaryColor}  !important;
				border-color: ${colorPalette.primaryColor}  !important;
			}
			.ngx-datatable.datatable .datatable-footer .datatable-pager li.active a {
				background: ${colorPalette.primaryColor}  !important;
			}
			.ngx-datatable.datatable .datatable-footer .datatable-pager li {
				border: 1px solid ${colorPalette.primaryColor}  !important;
				border-right: 1px solid ${colorPalette.primaryColor}  !important;
			}
			.pure-checkbox input[type="checkbox"]:checked  label:before {
				background: ${colorPalette.primaryColor}  !important;
			}
			.pure-checkbox input[type="checkbox"]:checked  label:after {
				background: ${colorPalette.primaryColor}  !important;
			}
			.pure-checkbox input[type="checkbox"]  label:before {
				border-color: ${colorPalette.primaryColor}  !important;
			}
			dp-day-calendar .dp-selected{
				background: ${colorPalette.primaryColor}  !important;
			}
			.primary-color .no_lift_data_header{
				color: ${colorPalette.primaryColor}  !important;
			background: white !important;
			}
			.quinary-color-bg .no_lift_data_header{
				color: ${colorPalette.quinaryColor}  !important;
			background: white !important;
			}
			.primary-color .no_lift_data_block{
				color: ${colorPalette.primaryColor}  !important;
			}
			.quinary-color-bg .no_lift_data_block{
				color: ${colorPalette.quinaryColor}  !important;
			}
			.verticalLine{
				border-left-color: ${colorPalette.primaryColor}  !important;
			}
			.drawCircle {
				border-color: ${colorPalette.primaryColor}  !important;
				background: ${colorPalette.primaryColor} ;
			}
			.c100:hover>span {
				color: ${colorPalette.primaryColor} !important
			}
			.pie,.c100 .bar,.c100.p51 .fill,.c100.p52 .fill,.c100.p53 .fill,.c100.p54 .fill,.c100.p55 .fill,.c100.p56 .fill,.c100.p57 .fill,.c100.p58 .fill,.c100.p59 .fill,.c100.p60 .fill,.c100.p61 .fill,.c100.p62 .fill,.c100.p63 .fill,.c100.p64 .fill,.c100.p65 .fill,.c100.p66 .fill,.c100.p67 .fill,.c100.p68 .fill,.c100.p69 .fill,.c100.p70 .fill,.c100.p71 .fill,.c100.p72 .fill,.c100.p73 .fill,.c100.p74 .fill,.c100.p75 .fill,.c100.p76 .fill,.c100.p77 .fill,.c100.p78 .fill,.c100.p79 .fill,.c100.p80 .fill,.c100.p81 .fill,.c100.p82 .fill,.c100.p83 .fill,.c100.p84 .fill,.c100.p85 .fill,.c100.p86 .fill,.c100.p87 .fill,.c100.p88 .fill,.c100.p89 .fill,.c100.p90 .fill,.c100.p91 .fill,.c100.p92 .fill,.c100.p93 .fill,.c100.p94 .fill,.c100.p95 .fill,.c100.p96 .fill,.c100.p97 .fill,.c100.p98 .fill,.c100.p99 .fill,.c100.p100 .fill {
				border-color: ${colorPalette.primaryColor} !important
			}
			.display-creative-v3-area-chart:nth-child(n) .creative-chart-header .creative-chart-header-text {
				background-color: ${colorPalette.primaryColor} !important;
			}
			.display-creative-v3-area-chart:nth-child(2n) .creative-chart-header .creative-chart-header-text {
				background-color: ${colorPalette.secondaryColor} !important;
			}
			.display-creative-v3-area-chart:nth-child(3n) .creative-chart-header .creative-chart-header-text {
				background-color: ${colorPalette.tertiaryColor} !important;
			}
			.display-creative-v3-area-chart:nth-child(4n) .creative-chart-header .creative-chart-header-text {
				background-color: ${colorPalette.quaternaryColor} !important;
			}
			.display-creative-v3-area-chart:nth-child(5n) .creative-chart-header .creative-chart-header-text {
				background-color: ${colorPalette.quinaryColor} !important;
			}
			.display-creative-header-v3:nth-child(n) .creative-chart-header-text {
				background-color: ${colorPalette.primaryColor} !important;
			}
			.display-creative-header-v3:nth-child(2n) .creative-chart-header-text {
				background-color: ${colorPalette.secondaryColor} !important;
			}
			.display-creative-header-v3:nth-child(3n) .creative-chart-header-text {
				background-color: ${colorPalette.tertiaryColor} !important;
			}
			.display-creative-header-v3:nth-child(4n) .creative-chart-header-text {
				background-color: ${colorPalette.quaternaryColor} !important;
			}
			.display-creative-header-v3:nth-child(5n) .creative-chart-header-text {
				background-color: ${colorPalette.quinaryColor} !important;
			}
			.display-creative-v3-legend-area .legend1 .legend_item:nth-child(n).legend_item_selected {
				background-color: ${colorPalette.primaryColor} !important;
			}
			.display-creative-v3-legend-area .legend1 .legend_item:nth-child(2n).legend_item_selected {
				background-color: ${colorPalette.secondaryColor} !important;
			}
			.display-creative-v3-legend-area .legend1 .legend_item:nth-child(3n).legend_item_selected {
				background-color: ${colorPalette.tertiaryColor} !important;
			}
			.display-creative-v3-legend-area .legend1 .legend_item:nth-child(4n).legend_item_selected {
				background-color: ${colorPalette.quaternaryColor} !important;
			}
			.display-creative-v3-legend-area .legend1 .legend_item:nth-child(5n).legend_item_selected {
				background-color: ${colorPalette.quinaryColor} !important;
			}
			 .report-attr-checkbox  label:before {
				  border: 2px solid ${colorPalette.primaryColor};
			}
			.daterangepicker.dropdown-menu .ranges {
				position: absolute;top: calc(100% - 45px); right: 10px
			}
			.daterangepicker td.active.start-date, .daterangepicker td.active.end-date, .daterangepicker td.active.start-date:hover, .daterangepicker td.active.end-date:hover{
				background-color: ${colorPalette.primaryColor} !important;
			}
			.daterangepicker .calendar td, .daterangepicker .calendar th {
				color: ${colorPalette.primaryColor} !important;
			}
			.daterangepicker td.in-range {
				background-color: ${this.getRGBByOpacity(colorPalette.primaryColor, 0.5)} !important;
			}
			.md-drppicker td.in-range, .md-drppicker td.active, .md-drppicker td.end-date, .md-drppicker .btn {
				background-color: ${colorPalette.primaryColor} !important;
			}
			.md-drppicker td.in-range {
				background-color : ${this.getRGBByOpacity(colorPalette.primaryColor, 0.5)}  !important;
			   color: ${colorPalette.primaryColor};
			}
			.daterangepicker tr td.in-range.available:first-child {
			   border-top-left-radius: 50%!important;
			   border-bottom-left-radius: 50%!important;
			}
			.daterangepicker tr td.in-range.available:last-child {
			   border-top-right-radius: 50%!important;
			   border-bottom-right-radius: 50%!important;
			}
			.daterangepicker td.off.in-range {
				background-color: transparent !important;
			}
			.daterangepicker.dropdown-menu .ranges .applyBtn {
				background-color: ${colorPalette.primaryColor} !important;
			   box-shadow: 0 0 0 2px ${this.getRGBByOpacity(colorPalette.primaryColor, 1)} !important;
			}
			.daterangepicker.dropdown-menu .ranges .applyBtn {
				background-color: ${colorPalette.primaryColor} !important;
			   box-shadow: 0 0 0 2px ${this.getRGBByOpacity(colorPalette.primaryColor, 1)}  !important;
			}
			.ng-dropdown-panel .checkbox-container, .ng-dropdown-panel .select-content,.ng-dropdown-panel .unselect-btn-container {
				color: ${colorPalette.primaryColor};
			}
			.daily-metrics-r5 .item_selected, .r5-devices .item_selected {
				color: ${colorPalette.primaryColor} !important;
			}
			.daily-metrics-r5 .item_selected, .r5-devices .item_selected {
				color: ${colorPalette.primaryColor} !important;
			}
			.daily-metrics-r5 .item_selected:after, .r5-devices .item_selected:after {
				border-right: 8px solid ${colorPalette.primaryColor} !important;
			}
			.ngx-datatable.v5datatable .datatable-footer .datatable-pager .pager li:not(.disabled).active a {
				background-color: ${colorPalette.primaryColor} !important;
			}
			.ngx-datatable.v5datatable .datatable-footer .datatable-pager .pager li:not(.disabled):hover a{
				background-color: ${this.getRGBByOpacity(colorPalette.primaryColor, 0.5)} !important;
			}
			.r6-nav-tabs li .selected {
				background: ${colorPalette.primaryColor} !important;
			}
			.navigation-widgets li.selected{
				background-color: ${colorPalette.primaryColor} !important;
			}
			.navigation-widgets li{
				background-color: ${this.getRGBByOpacity(colorPalette.primaryColor, 0.5)} !important;
			}
			.r7-nav-tabs .navigation-widgets li.selected{
				background-color: ${colorPalette.secondaryColor} !important;
			}
			.r7-nav-tabs .navigation-widgets li{
				background-color: ${this.getRGBByOpacity(colorPalette.secondaryColor, 0.5)} !important;
			}
			.r7_quick_stats h5, .r7_primary_bg_color, .r7-portlet .c-portlet__header, .r7-portlet .c-portlet__header.o-stack.o-stack--center.o-stack--splitted.u-border-bottom.u-px-small.u-py-mini.c-portlet-gap.u-border-bottom {
				background-color: ${colorPalette.primaryColor} !important;
			}
			.r7_quick_stats .span_intraction, .r7_quick_stats .u-font-medium{
				color: ${colorPalette.primaryColor} !important;
			}
			.ng-dropdown-panel .dropdown-search-input{
				border: 1px solid ${colorPalette.primaryColor} !important;
			}
			.primary-svg-stroke {
				stroke: ${colorPalette.primaryColor} !important;
			}
			.primary-svg-fill {
				fill: ${colorPalette.primaryColor} !important;
			}
			.primary-svg-fill-linear-gradient {
				fill: url(${colorPalette.primaryColor}) !important;
			}
			.r11-navigation .ng-dropdown-panel .checkbox-container input ~ .checkmark{
				border-color : ${colorPalette.secondaryColor} !important
			}
			.r11-navigation .ng-dropdown-panel .checkbox-container:hover input ~ .checkmark,
			.r11-navigation .ng-dropdown-panel .checkbox-container input:checked ~ .checkmark {
				background-color: ${colorPalette.secondaryColor} !important;
			}
			.r11-navigation .ng-select-container {
				border-color: ${colorPalette.primaryColor} !important;
			}
			.r11-navigation .md-drppicker td.in-range {
				background-color : ${colorPalette.primaryColor} !important;
			   color:  inherit;
			}
			.r11-navigation .md-drppicker .btn.btn-default {
				border-color: ${colorPalette.primaryColor} !important;
				color: ${colorPalette.primaryColor} !important;
			}
			.r11-navigation .navigation-widgets li {
				background-color: ${this.getRGBByOpacity(colorPalette.secondaryColor, 0.6)} !important;
			}
			.r11-navigation .navigation-widgets li.selected {
				background-color: ${colorPalette.secondaryColor} !important;
			}
			.primary-outline-color {
				outline-color: ${colorPalette.primaryColor} !important;
			}
			.secondary-svg-fill {
				fill: ${colorPalette.secondaryColor} !important;
			}
			.devices-r7.legend-inactive {
				background-color: ${colorPalette.tertiaryColor} !important;
				opacity: 0.65 !important;
			}`;
		return miscStyles;
	}

	private mapStyles(colorPalette: ColorPalette): string {
		const mapStyles = `
			.map-product-item {
				border-color: ${colorPalette.primaryColor} !important;
				color: ${colorPalette.primaryColor} !important;
			}
			.map-product-item:hover {
			   background-color: #FFFFFF !important;
			   color: ${colorPalette.primaryColor} !important;
			}
			.map-product-item-selected {
			   background-color: ${colorPalette.primaryColor} !important;
			   color: #ffffff !important;
			}
			.r7-map-product-item-deselected {
			   background-color: #ffffff !important;
			   color: ${colorPalette.tertiaryColor} !important;
			   opacity: 0.65;
			   border: 1px solid ${colorPalette.tertiaryColor} !important;
			}
			.r7-map-product-item-deselected:hover {
			   background-color: ${colorPalette.tertiaryColor} !important;
			   color: #ffffff !important;
			   opacity: 0.65;
			}
			.r7-map-product-item-selected {
			   background-color: ${colorPalette.tertiaryColor} !important;
			   color: #ffffff !important;
			}
			.map-product-item-selected:hover {
			   background-color: ${colorPalette.primaryColor} !important;
			   color: #ffffff !important;
			}
			.r7-map-product-item-selected:hover {
			   background-color: ${colorPalette.tertiaryColor} !important;
			   color: #ffffff !important;
			}
			.ngx-datatable.datatable .datatable-footer .datatable-pager li.active, .ngx-datatable.datatable .datatable-footer .datatable-pager li.active:hover {
				background: ${colorPalette.primaryColor} !important;
				border-color: ${colorPalette.primaryColor} !important;
			}
			.geofence-badge{
				border-color: ${colorPalette.primaryColor} !important;
				color: ${colorPalette.primaryColor} !important;
			}
			.geofence-badge:hover{
				color: ${colorPalette.primaryColor} !important;
			}
			.geofence-badge-selected {
			  	background-color: ${colorPalette.primaryColor} !important;
				color: #ffffff !important;
			}
			.geofence-badge-selected:hover {
				background-color: ${colorPalette.primaryColor} !important;
				color: #ffffff !important;
			}
			.leaflet-marker-icon {
				border-color: ${colorPalette.primaryColor} !important;
			}`;
		return mapStyles;
	}

	private creativePerformanceCarouselStyles(colorPalette: ColorPalette): string {
		const carouselStyles = `
			.creative-performance-stats .carousel-points-container li:nth-child(n){
				border-color: ${colorPalette.primaryColor} !important;
				background-color: ${this.getRGBByOpacity(colorPalette.primaryColor, 0.6)} !important;
			}
			.creative-performance-stats .carousel-points-container li:nth-child(2n){
				border-color: ${colorPalette.secondaryColor} !important;
				background-color: ${this.getRGBByOpacity(colorPalette.secondaryColor, 0.6)} !important;
			}
			.creative-performance-stats .carousel-points-container li:nth-child(3n){
				border-color: ${colorPalette.tertiaryColor} !important;
				background-color: ${this.getRGBByOpacity(colorPalette.tertiaryColor, 0.6)} !important;
			}
			.creative-performance-stats .carousel-points-container li:nth-child(4n){
				border-color: ${colorPalette.quaternaryColor} !important;
				background-color: ${this.getRGBByOpacity(colorPalette.quaternaryColor, 0.6)} !important;
			}
			.creative-performance-stats .carousel-points-container li:nth-child(5n){
				border-color: ${colorPalette.quinaryColor} !important;
				background-color: ${this.getRGBByOpacity(colorPalette.quinaryColor, 0.6)} !important;
			}
			.creative-performance-stats .carousel-points-container li:not(.active){
				background-color: #FFFFFF !important;
			}
			.display-creative-container .carousel-points-container li:nth-child(n).active {
				box-shadow: 0 0 0 2px white, 0 0 0 4px ${this.getRGBByOpacity(colorPalette.primaryColor, 1)} !important;
			}
			.display-creative-container .carousel-points-container li:nth-child(2n).active {
				box-shadow: 0 0 0 2px white, 0 0 0 4px ${this.getRGBByOpacity(colorPalette.secondaryColor, 1)} !important;
			}
			.display-creative-container .carousel-points-container li:nth-child(3n).active {
				box-shadow: 0 0 0 2px white, 0 0 0 4px ${this.getRGBByOpacity(colorPalette.tertiaryColor, 1)} important;
			}
			.display-creative-container .carousel-points-container li:nth-child(4n).active {
				box-shadow: 0 0 0 2px white, 0 0 0 4px ${this.getRGBByOpacity(colorPalette.quaternaryColor, 1)} important;
			}
			.display-creative-container .carousel-points-container li:nth-child(5n).active {
				box-shadow: 0 0 0 2px white, 0 0 0 4px ${this.getRGBByOpacity(colorPalette.quinaryColor, 1)} important;
			}
			.display-creative-container .carousel-points-container li:nth-child(n){
				background-color: ${this.getRGBByOpacity(colorPalette.primaryColor, 1)} important;
			}
			.display-creative-container .carousel-points-container li:nth-child(2n){
				background-color: ${this.getRGBByOpacity(colorPalette.secondaryColor, 1)} important;
			}
			.display-creative-container .carousel-points-container li:nth-child(3n) {
				background-color: ${this.getRGBByOpacity(colorPalette.tertiaryColor, 1)} important;
			}
			.display-creative-container .carousel-points-container li:nth-child(4n) {
				background-color: ${this.getRGBByOpacity(colorPalette.quaternaryColor, 1)} important;
			}
			.display-creative-container .carousel-points-container li:nth-child(5n) {
				background-color: ${this.getRGBByOpacity(colorPalette.quinaryColor, 1)} important;
			}
			.creative-performance-stats .carousel-points-container-r5 li:nth-child(n){
				border-color: ${colorPalette.primaryColor} !important;
				background-color: ${this.getRGBByOpacity(colorPalette.primaryColor, 0.6)};
			;
			}
			.creative-performance-stats .carousel-points-container-r5 li:nth-child(2n){
				border-color: ${colorPalette.secondaryColor} !important;
				background-color: ${this.getRGBByOpacity(colorPalette.secondaryColor, 0.6)};
			}
			.creative-performance-stats .carousel-points-container-r5 li:nth-child(3n){
				border-color: ${colorPalette.tertiaryColor} !important;
				background-color: ${this.getRGBByOpacity(colorPalette.tertiaryColor, 0.6)};
			}
			.creative-performance-stats .carousel-points-container-r5 li:nth-child(4n){
				border-color: ${colorPalette.quaternaryColor} !important;
				background-color: ${this.getRGBByOpacity(colorPalette.quaternaryColor, 0.6)};
			}
			.creative-performance-stats .carousel-points-container-r5 li:nth-child(5n){
				border-color: ${colorPalette.quinaryColor} !important;
				background-color: ${this.getRGBByOpacity(colorPalette.quinaryColor, 0.6)};
			}
			.display-creative-container .carousel-points-container-r5 li:nth-child(n).active {
				box-shadow: 0 0 0 2px white, 0 0 0 4px ${this.getRGBByOpacity(colorPalette.primaryColor, 1)} !important;
			}
			.display-creative-container .carousel-points-container-r5 li:nth-child(2n).active {
				box-shadow: 0 0 0 2px white, 0 0 0 4px ${this.getRGBByOpacity(colorPalette.secondaryColor, 1)} !important;
			}
			.display-creative-container .carousel-points-container-r5 li:nth-child(3n).active {
				box-shadow: 0 0 0 2px white, 0 0 0 4px ${this.getRGBByOpacity(colorPalette.tertiaryColor, 1)}!important;
			}
			.display-creative-container .carousel-points-container-r5 li:nth-child(4n).active {
				box-shadow: 0 0 0 2px white, 0 0 0 4px ${this.getRGBByOpacity(colorPalette.quaternaryColor, 1)}!important;
			}
			.display-creative-container .carousel-points-container-r5 li:nth-child(5n).active {
				box-shadow: 0 0 0 2px white, 0 0 0 4px ${this.getRGBByOpacity(colorPalette.quinaryColor, 1)}!important;
			}
			.display-creative-container .carousel-points-container-r5 li:nth-child(n){
				background-color: ${this.getRGBByOpacity(colorPalette.primaryColor, 1)};
			}
			.display-creative-container .carousel-points-container-r5 li:nth-child(2n){
				background-color: ${this.getRGBByOpacity(colorPalette.secondaryColor, 1)};
			}
			.display-creative-container .carousel-points-container-r5 li:nth-child(3n) {
				background-color: ${this.getRGBByOpacity(colorPalette.tertiaryColor, 1)};
			}
			.display-creative-container .carousel-points-container-r5 li:nth-child(4n) {
				background-color: ${this.getRGBByOpacity(colorPalette.quaternaryColor, 1)};
			}
			.display-creative-container .carousel-points-container-r5 li:nth-child(5n) {
				background-color: ${this.getRGBByOpacity(colorPalette.quinaryColor, 1)};
			}`;
		return carouselStyles;
	}

	private getRGBFromHex(hex: string): any {
		const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
		return result
			? {
					r: parseInt(result[1], 16),
					g: parseInt(result[2], 16),
					b: parseInt(result[3], 16)
			  }
			: null;
	}

	private generateRGBCssProperty(rgbObject: any, opacity: any): string {
		const rgba = `rgba(${rgbObject.r}, ${rgbObject.g}, ${rgbObject.b}, ${opacity})`;
		return rgba;
	}
}
